import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';
import { CASHLESS_PAY_TYPES } from '../../../components';

export default () => {
  // Set Localization
  const { translate } = useTranslation();

  const schema = yup.object({
    id: yup.string().nullable().optional(),
    name: yup
      .string()
      .nullable()
      .test({
        name: 'test-empty-string',
        test(value, ctx) {
          if (value?.startsWith(' ')) {
            return ctx.createError({ message: translate(`errorMessages.startSpace`) });
          }
          return true;
        },
      })
      .required(translate(`errorMessages.required`))
      .max(64, translate(`errorMessages.max`, { count: 64 })),
    type: yup.string().nullable().required(translate(`errorMessages.required`)),
    voucher_webview: yup
      .string()
      .nullable()
      .url(translate(`errorMessages.invalidURL`))
      .required(translate(`errorMessages.required`)),
    webview: yup
      .string()
      .nullable()
      .url(translate(`errorMessages.invalidURL`))
      .required(translate(`errorMessages.required`)),
    freedompay: yup.object().when('type', {
      // FreedomPay keys
      is: (type: string) => type === CASHLESS_PAY_TYPES.FREEDOM_PAY,
      then: yup.object({
        badge_pay_system_key: yup.string().nullable().required(translate(`errorMessages.required`)),
      }),
    }),
    tenders: yup
      .array()
      .nullable()
      .when('type', {
        is: (type: string) => type === CASHLESS_PAY_TYPES.FREEDOM_PAY,
        then: yup
          .array()
          .nullable()
          .of(
            yup.object({
              name: yup.string().nullable().required(translate(`errorMessages.required`)),
              tax_exempt: yup.boolean().nullable().required(translate(`errorMessages.required`)),
              type: yup.string().nullable().required(translate(`errorMessages.required`)),
            }),
          )
          .min(1, translate(`errorMessages.minValue`, { minValue: 1 }))
          .required(translate(`errorMessages.required`)),
      }),
  });

  return { schema };
};
